import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgShirt = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 15.35 11.84",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:#fff;}" }) }),
		/* @__PURE__ */ _jsx("polygon", {
			className: "cls-1",
			points: "11.24 11.32 3.82 11.32 3.85 4.75 .99 4.92 .58 3.26 .42 2.17 3.82 .52 10.07 .67 10.51 .45 15.06 2.2 14.51 4.81 11.35 4.98 11.24 11.32"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M5.23,0h-.09L.18,1.81c-.12.04-.2.17-.17.3l.62,2.95c.03.12.13.21.26.21h2.7v6.31c0,.15.12.26.26.26h7.66c.15,0,.26-.12.26-.26v-6.31h2.7c.13,0,.23-.09.26-.21l.62-2.95c.03-.13-.04-.26-.17-.3L10.24.02h-.15s-.03,0-.04,0h-.01c-.63.3-1.45.49-2.35.49s-1.73-.19-2.35-.49h-.09l-.02-.03ZM5.04.61c.39,1.08,1.43,1.85,2.64,1.85s2.25-.77,2.64-1.85l4.46,1.62-.53,2.52h-2.75c-.15,0-.26.12-.26.26v6.31h-7.13v-6.31c0-.15-.12-.26-.26-.26H1.11l-.53-2.52L5.04.61ZM5.67.73c.6.2,1.28.31,2.01.31s1.41-.11,2.01-.31c-.38.71-1.14,1.2-2.01,1.2s-1.62-.48-2.01-1.2Z" })
	]
});
export default SvgShirt;
